import LTR from "@brand-icons/ploom/pin-store-active/pin-store-active-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinStoreActiveIcon = iconFactory("PinStoreActiveIcon", LTR);
